export const Container = {
  baseStyle: {
    maxW: 'container.xl',
    justifyContent: 'center',
    w: 'full',
    px: 4
  }
}
